import { CatIconInfo } from 'blocks-nextjs/blocks-react/components/Icons/Info';
import { CatTextLink } from 'blocks-nextjs/blocks-react/components/TextLink';
import { CatTextPassage } from 'blocks-nextjs/blocks-react/components/TextPassage';
import { CatTooltip } from 'blocks-nextjs/blocks-react/components/Tooltip';
import { useTranslations } from 'next-intl';
import cx from 'classnames';
import styles from '../price.module.scss';

const DiscountPrice = ({ price }) => {
  const t = useTranslations();
  const showDiscountPrice = price?.unitPrice !== price?.discountedPrice;
  return (
    <>
      {showDiscountPrice && (
        <s>
          <p className={cx('m-0', styles['gray-text'])}>
            {`${price?.unitPrice}`} {t('ITEM_EA_ABB')}
          </p>
        </s>
      )}
      {!!price?.coreCharges && (
        <>
          <CatTooltip isInteractive data-testid="checkmark">
            <CatTextLink
              size="sm"
              slot="trigger"
              className="cat-u-theme-typography-footnote"
            >
              <span className="text-end">{t('CAT_CORE_DEPOSIT_TITLE')}</span>
              <span className="ps-1 pt-1">
                <CatIconInfo />
              </span>
            </CatTextLink>
            <CatTextPassage size="xs">
              {t('CAT_CORE_DEPOSIT_TOOLTIP_CONTENT')}
            </CatTextPassage>
          </CatTooltip>
          <p className={cx('m-0', styles['gray-text'])}>
            {`${price?.coreCharges} ${t('ITEM_EA_ABB')}`}
          </p>
        </>
      )}
    </>
  );
};

export default DiscountPrice;
